<template>
    <section id="form_section">
        <div class="container">
            <div v-if="show_error" class="alert-danger mb-12">
                <p>Будь ласка, перевірте обов'язкові поля!</p>
            </div>
            <div class="head_row">
                <div class="text-column">
                    <h1 class="title">Сухий трансформатор</h1>
                    <p class="subtitle">Опитувальний лист для замовлення</p>
                </div>
                <a :href="file" target="_blank" class="btn-download">
                    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="download-icon" d="M14 6.5H10V0.5H4V6.5H0L7 13.5L14 6.5ZM0 15.5V17.5H14V15.5H0Z" fill="#356EEF"/>
                    </svg>
                    В форматі MS Word
                </a>
            </div>
            <div class="flex-group customer_info mt-8">
                <div class="flex_form">
                    <p class="form_subtitle">Дані про замовника:</p>
                    <div class="flex-row">
                        <div class="form_grid">
                            <div class="form_group">
                                <label class="form_label">Організація *</label>
                                <input class="form_input" :class="{ 'border-danger': errors.org_name }" v-model="formData.org_name" type="text" placeholder="Назва" />
                                <p class="error_text" v-if="errors.org_name">Обов'язкове поле</p>
                            </div>
                            <div class="form_group">
                                <label class="form_label">Контактна особа *</label>
                                <input class="form_input" :class="{ 'border-danger': errors.name }" v-model="formData.name" type="text" placeholder="ПІБ" />
                                <p class="error_text" v-if="errors.name">Обов'язкове поле</p>
                            </div>
                        </div>
                        <div class="form_grid">
                            <div class="form_group">
                                <label class="form_label">Номер телефону *</label>
                                <input class="form_input" :class="{ 'border-danger': errors.phone }" @input="acceptNumber" v-model="formData.phone" type="text" placeholder="+380" />
                                <p class="error_text" v-if="errors.phone">Обов'язкове поле</p>
                            </div>
                            <div class="form_group">
                                <label class="form_label">Електронна пошта *</label>
                                <input class="form_input" :class="{ 'border-danger': errors.email }" v-model="formData.email" type="text" placeholder="Email" />
                                <p class="error_text" v-if="errors.email">Обов'язкове поле</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex_form">
                    <p class="form_subtitle">Об’єкт:</p>
                    <div class="flex-row">
                        <div class="form_group mr-9">
                            <label class="form_label">Найменування та адреса *</label>
                            <textarea  :class="{ 'border-danger': errors.address }" v-model="formData.address" class="form_input form_textarea" rows="5" placeholder="Найменування та адреса"></textarea>
                            <p class="error_text" v-if="errors.address">Обов'язкове поле</p>
                        </div>
                        <div class="form_group flex_centered">
                            <img src="/img/dry_trans.png" class="trans_img" width="170" height="170" alt="image">
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-8 main_content">
                <p class="block_title mb-5">Технічні параметри трансформатора</p>
                <div class="select_grid">
                    <div class="form_grid">
                        <div class="form_grid mb-12">
                            <div class="form_group">
                                <label class="form_label mb-12">Потужність, кВА</label>
                                <div class="input_group">
                                    <input type="radio" v-model="formData.power.select" value="selected" class="form_radio">
                                    <select v-model="formData.power.selected.value" class="form_input form_select">
                                        <option :value="40">40</option>
                                        <option :value="50">50</option>
                                        <option :value="63">63</option>
                                        <option :value="100">100</option>
                                        <option :value="160">160</option>
                                        <option :value="200">200</option>
                                        <option :value="250">250</option>
                                        <option :value="315">315</option>
                                        <option :value="400">400</option>
                                        <option :value="500">500</option>
                                        <option :value="630">630</option>
                                        <option :value="800">800</option>
                                        <option :value="1000">1000</option>
                                        <option :value="1600">1600</option>
                                        <option :value="2000">2000</option>
                                        <option :value="2500">2500</option>
                                        <option :value="3150">3150</option>
                                        <option :value="4000">4000</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form_group">
                                <div class="input_group">
                                    <input v-model="formData.power.select" value="custom" type="radio" class="form_radio">
                                    <input :class="{ 'border-danger': errors.power }" v-model="formData.power.custom.value" class="form_input" type="number" placeholder="Інший варіант" />
                                </div>
                                <p class="error_text" v-if="errors.power">Обов'язкове поле</p>
                            </div>
                        </div>
                        <div class="form_grid mb-12">
                            <div class="form_group">
                                <label class="form_label mb-12">Номінальна напруга ВН, кВ</label>
                                <div class="input_group">
                                    <label class="form_label">
                                        <input v-model="formData.material_BH_KB.select" :value="6" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">6</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.material_BH_KB.select" :value="10" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">10</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.material_BH_KB.select" :value="35" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">35</span>
                                    </label>
                                </div>
                            </div>

                            <div class="form_group">
                                <div class="input_group">
                                    <input v-model="formData.material_BH_KB.select" value="custom" type="radio" class="form_radio">
                                    <input :class="{ 'border-danger': errors.material_BH_KB }" v-model="formData.material_BH_KB.custom.value" class="form_input" type="number" placeholder="Інший варіант" />
                                </div>
                                <p class="error_text" v-if="errors.material_BH_KB">Обов'язкове поле</p>
                            </div>
                        </div>
                        <div class="form_grid">
                            <div class="form_group">
                                <label class="form_label mb-12">Номінальна напруга НН, кВ</label>
                                <div class="input_group">
                                    <label class="form_label">
                                        <input v-model="formData.material_HH_KB.select" :value="0.4" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">0.4</span>
                                    </label>
                                </div>
                            </div>

                            <div class="form_group">
                                <div class="input_group">
                                    <input v-model="formData.material_HH_KB.select" value="custom" type="radio" class="form_radio">
                                    <input :class="{ 'border-danger': errors.material_HH_KB }" v-model="formData.material_HH_KB.custom.value" class="form_input" type="number" placeholder="Інший варіант" />
                                    
                                </div>
                                <p class="error_text" v-if="errors.material_HH_KB">Обов'язкове поле</p>
                            </div>
                        </div>

                        <div class="form_grid mb-12">
                            <div class="form_group">
                                <label class="form_label mb-12">Серія</label>
                                <div class="form_grid">
                                    <label class="form_label">
                                        <input v-model="formData.series" value="Стандартні втрати" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Стандартні втрати</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.series" value="Знижені втрати ECO T1" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Знижені втрати ECO T1</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.series" value="Знижені втрати ECO T2" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Знижені втрати ECO T2</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="form_grid mb-12">
                            <div class="form_group">
                                <label class="form_label mb-12">Призначення</label>
                                <div class="form_grid">
                                    <label class="form_label">
                                        <input v-model="formData.destination.select" value="Розподіл електроенергії" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Розподіл електроенергії</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.destination.select" value="Для частотних перетворювачів" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Для частотних перетворювачів</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.destination.select" value="Сонячні електростанції" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Сонячні електростанції</span>
                                    </label>
                                    <div class="input_group">
                                        <input v-model="formData.destination.select" value="custom" type="radio" class="form_radio">
                                        <input :class="{ 'border-danger': errors.destination }" v-model="formData.destination.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                        
                                    </div>
                                    <p class="error_text" v-if="errors.destination">Обов'язкове поле</p>
                                </div>
                            </div>
                        </div>
                        <div class="form_grid mb-12 hidden">
                            <div class="form_group mb-12">
                                <label class="form_label mb-12">Матеріал обмотки ВН</label>
                                <div class="input_group max-width-radio">
                                    <label class="form_label">
                                        <input v-model="formData.material_BH" value="Al" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Al</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.material_BH" value="Cu" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Cu</span>
                                    </label>
                                </div>
                            </div>
                            <div class="form_group mb-12">
                                <label class="form_label mb-12">Матеріал обмотки НН</label>
                                <div class="input_group max-width-radio">
                                    <label class="form_label">
                                        <input v-model="formData.material_HH" value="Al" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Al</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.material_HH" value="Cu" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Cu</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form_grid mb-12 hidden">
                            <div class="form_group">
                                <label class="form_label mb-12">Схема та група з’єднання обмоток</label>
                                <div class="input_group max-width-radio-init">
                                    <label class="form_label">
                                        <input v-model="formData.winding_scheme.select" value="∆/Yn-11" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">∆/Yn-11</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.winding_scheme.select" value="Y/Yn-0" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Y/Yn-0</span>
                                    </label>
                                </div>
                                <div class="input_group">
                                    <input v-model="formData.winding_scheme.select" value="custom" type="radio" class="form_radio">
                                    <input :class="{ 'border-danger': errors.winding_scheme }" v-model="formData.winding_scheme.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                    
                                </div>
                                <p class="error_text" v-if="errors.winding_scheme">Обов'язкове поле</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form_grid to_hide">
                        
                        <div class="form_group mb-12">
                            <label class="form_label mb-12">Матеріал обмотки ВН</label>
                            <div class="input_group max-width-radio">
                                <label class="form_label">
                                    <input v-model="formData.material_BH" value="Al" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Al</span>
                                </label>
                                <label class="form_label">
                                    <input v-model="formData.material_BH" value="Cu" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Cu</span>
                                </label>
                            </div>
                        </div>
                        <div class="form_group mb-12">
                            <label class="form_label mb-12">Матеріал обмотки НН</label>
                            <div class="input_group max-width-radio">
                                <label class="form_label">
                                    <input v-model="formData.material_HH" value="Al" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Al</span>
                                </label>
                                <label class="form_label">
                                    <input v-model="formData.material_HH" value="Cu" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Cu</span>
                                </label>
                            </div>
                        </div>

                        <div class="form_grid mb-12">
                            <div class="form_group">
                                <label class="form_label mb-12">Схема та група з’єднання обмоток</label>
                                <div class="input_group max-width-radio-init">
                                    <label class="form_label">
                                        <input v-model="formData.winding_scheme.select" value="∆/Yn-11" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">∆/Yn-11</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.winding_scheme.select" value="Y/Yn-0" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Y/Yn-0</span>
                                    </label>
                                </div>
                                <div class="input_group">
                                    <input v-model="formData.winding_scheme.select" value="custom" type="radio" class="form_radio">
                                    <input :class="{ 'border-danger': errors.winding_scheme }"  v-model="formData.winding_scheme.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                    
                                </div>
                                <p class="error_text" v-if="errors.winding_scheme">Обов'язкове поле</p>
                            </div>
                        </div>

                        <div class="form_grid mb-12">
                            <div class="form_group">
                                <label class="form_label mb-12">Спосіб і діапазон регулювання напруги:</label>
                                <label class="form_label mb-12 form_label_secondary">Переключення без збудження (ПБЗ), %</label>
                                <div class="input_group">
                                    <label class="form_label">
                                        <input v-model="formData.voltage_method.select" value="+/- 2х2,5%" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">+/- 2х2,5%</span>
                                    </label>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group">
                                        <input v-model="formData.voltage_method.select" value="custom" type="radio" class="form_radio">
                                        <input :class="{ 'border-danger': errors.voltage_method_1 }" v-model="formData.voltage_method.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                        
                                    </div>
                                    <p class="error_text" v-if="errors.voltage_method_1">Обов'язкове поле</p>
                                </div>
                                <label class="form_label mb-12 form_label_secondary">Регулювання під навантаженням (РПН), %</label>
                                <div class="input_group">
                                    <label class="form_label">
                                        <input v-model="formData.voltage_method.select" value="+/- 4х2,5%" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">+/- 4х2,5%</span>
                                    </label>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group">
                                        <input v-model="formData.voltage_method.select" value="custom_2" type="radio" class="form_radio">
                                        <input :class="{ 'border-danger': errors.voltage_method_2 }" v-model="formData.voltage_method.custom.value_2" class="form_input" type="text" placeholder="Інший варіант" />
                                        
                                    </div>
                                    <p class="error_text" v-if="errors.voltage_method_2">Обов'язкове поле</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="form_grid">
                        <div class="form_grid mb-12 hidden">
                            <div class="form_group">
                                <label class="form_label mb-12">Спосіб і діапазон регулювання напруги:</label>
                                <label class="form_label mb-12 form_label_secondary">Переключення без збудження (ПБЗ), %</label>
                                <div class="input_group">
                                    <label class="form_label">
                                        <input v-model="formData.voltage_method.select" value="+/- 2х2,5%" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">+/- 2х2,5%</span>
                                    </label>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group">
                                        <input v-model="formData.voltage_method.select" value="custom" type="radio" class="form_radio">
                                        <input :class="{ 'border-danger': errors.voltage_method_1 }" v-model="formData.voltage_method.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                        
                                    </div>
                                    <p class="error_text" v-if="errors.voltage_method_1">Обов'язкове поле</p>
                                </div>
                                <label class="form_label mb-12 form_label_secondary">Регулювання під навантаженням (РПН), %</label>
                                <div class="input_group">
                                    <label class="form_label">
                                        <input v-model="formData.voltage_method.select" value="+/- 4х2,5%" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">+/- 4х2,5%</span>
                                    </label>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group">
                                        <input v-model="formData.voltage_method.select" value="custom_2" type="radio" class="form_radio">
                                        <input :class="{ 'border-danger': errors.voltage_method_2 }" v-model="formData.voltage_method.custom.value_2" class="form_input" type="text" placeholder="Інший варіант" />
                                        
                                    </div>
                                    <p class="error_text" v-if="errors.voltage_method_2">Обов'язкове поле</p>
                                </div>
                            </div>
                        </div>
                        

                        <div class="form_group mb-12">
                            <label class="form_label mb-12">Вид підключення НН</label>
                            <div class="input_group max-width-radio mobile_selects">
                                <label class="form_label">
                                    <input v-model="formData.type_HH" value="Зверху" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Зверху</span>
                                </label>
                                <label class="form_label">
                                    <input v-model="formData.type_HH" value="Знизу" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Знизу</span>
                                </label>
                                <label class="form_label">
                                    <input v-model="formData.type_HH" value="Збоку" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Збоку</span>
                                </label>
                            </div>
                        </div>
                        <div class="form_group mb-12">
                            <label class="form_label mb-12">Вид підключення ВН</label>
                            <div class="input_group max-width-radio mobile_selects">
                                <label class="form_label">
                                    <input v-model="formData.type_BH" value="Зверху" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Зверху</span>
                                </label>
                                <label class="form_label">
                                    <input v-model="formData.type_BH" value="Знизу" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Знизу</span>
                                </label>
                                <label class="form_label">
                                    <input v-model="formData.type_BH" value="Збоку" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">Збоку</span>
                                </label>
                            </div>
                        </div>
                        <div class="form_grid mb-12">
                            <div class="form_group">
                                <label class="form_label mb-12">Спосіб підключення НН</label>
                                <div class="form_grid">
                                    <label class="form_label">
                                        <input v-model="formData.type_connect_HH.select" value="Плетена шина" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Плетена шина</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.type_connect_HH.select" value="Гнучка шина" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Гнучка шина</span>
                                    </label>
                                    <label class="form_label">
                                        <input v-model="formData.type_connect_HH.select" value="Кабель" type="radio" class="form_radio">
                                        <span class="selected_value weight-400">Кабель</span>
                                    </label>
                                    <div class="input_group">
                                        <input v-model="formData.type_connect_HH.select" value="custom" type="radio" class="form_radio">
                                        <input :class="{ 'border-danger': errors.type_connect_HH }" v-model="formData.type_connect_HH.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                        
                                    </div>
                                    <p class="error_text" v-if="errors.type_connect_HH">Обов'язкове поле</p>
                                </div>
                            </div>
                        </div>
                        <div class="form_group mb-12">
                            <label class="form_label mb-12">Клас нагрівостійкості ізоляції</label>
                            <div class="input_group">
                                <label class="form_label">
                                    <input v-model="formData.heat_resistance_class" value="F" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">F</span>
                                </label>
                                <label class="form_label">
                                    <input v-model="formData.heat_resistance_class" value="H" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">H</span>
                                </label>
                            </div>
                        </div>
                        <div class="form_group mb-12 max-width">
                            <label class="form_label mb-12">Температура експлуатації, °C</label>
                            <div class="input_group">
                                <label class="form_label">
                                    <input v-model="formData.operating_temperature.select" value="-25 °C  +40 °C" type="radio" class="form_radio">
                                    <span class="selected_value weight-400">-25 °C  +40 °C</span>
                                </label>
                            </div>
                            <div class="form_group">
                                <div class="input_group">
                                    <input v-model="formData.operating_temperature.select" value="custom" type="radio" class="form_radio">
                                    <input :class="{ 'border-danger': errors.operating_temperature }" v-model="formData.operating_temperature.custom.value" class="form_input" type="text" placeholder="Інший варіант" />
                                    
                                </div>
                                <p class="error_text" v-if="errors.operating_temperature">Обов'язкове поле</p>
                            </div>
                        </div>

                        <div class="form_group mb-12 max-width">
                            <div class="input_group flex-betwen">
                                <label class="form_label">Кількість тр-в., шт. *</label>
                                <input :class="{ 'border-danger': errors.count }" v-model="formData.count" class="form_input count_input" type="text" placeholder="" />
                            </div>
                            <p class="error_text" v-if="errors.count">Обов'язкове поле</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="toggle_row mt-8">
                <div class="toggle">
                    <div class="toggle_header" :class="{ active: is_toggle }" v-on:click="toggle()">
                        <label class="form_label">Комплектація та додаткові вимоги</label>

                        <svg class="cater" :class="{ active: is_toggle }" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z" fill="#356EEF"/>
                        </svg>
                    </div>
                    <div class="toggle_content" v-if="is_toggle">
                        <div class="select_grid">
                            <div class="form_grid grid_left">
                                <div class="form_grid mb-12">
                                    <div class="form_group">
                                        <label class="form_label mb-12">Блок контролю температури</label>
                                        <div class="form_grid">
                                            <label class="form_label">
                                                <input v-model="formData.temperature_control_unit.select" value="Т-154" type="radio" class="form_radio">
                                                <span class="selected_value weight-400">Т-154</span>
                                            </label>
                                            <label class="form_label">
                                                <input v-model="formData.temperature_control_unit.select" value="NT935 AD (з RS 485)" type="radio" class="form_radio">
                                                <span class="selected_value weight-400">NT935 AD (з RS 485)</span>
                                            </label>
                                            <label class="form_label">
                                                <input v-model="formData.temperature_control_unit.select" value="NT935 ETH (з Ethernet)" type="radio" class="form_radio">
                                                <span class="selected_value weight-400">NT935 ETH (з Ethernet)</span>
                                            </label>
                                            <div class="input_group">
                                                <input v-model="formData.temperature_control_unit.select" value="custom" type="radio" class="form_radio">
                                                <input :class="{ 'border-danger': errors.temperature_control_unit }" v-model="formData.temperature_control_unit.custom.value" class="form_input mobile_drop_input" type="text" placeholder="Інший варіант" />
                                                
                                            </div>
                                            <p class="error_text" v-if="errors.temperature_control_unit">Обов'язкове поле</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="form_grid mb-12">
                                    <div class="form_group">
                                        <label class="form_label mb-12">Датчики температури</label>
                                        <div class="form_grid">
                                            <label class="form_label">
                                                <input v-model="formData.temperature_sensors.select" value="РТ-100 (4шт.)" type="radio" class="form_radio">
                                                <span class="selected_value weight-400">РТ-100 (4шт.)</span>
                                            </label>
                                            <div class="input_group">
                                                <input v-model="formData.temperature_sensors.select" value="custom" type="radio" class="form_radio">
                                                <input :class="{ 'border-danger': errors.temperature_sensors }" v-model="formData.temperature_sensors.custom.value" class="form_input mobile_drop_input" type="text" placeholder="Інший варіант" />
                                                
                                            </div>
                                            <p class="error_text" v-if="errors.temperature_sensors">Обов'язкове поле</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="form_grid mb-12">
                                    <div class="form_group">
                                        <label class="form_label mb-12">Захисний кожух</label>
                                        <div class="form_grid">
                                            <label class="form_label">
                                                <input v-model="formData.protective_casing.select" value="IP31" type="radio" class="form_radio">
                                                <span class="selected_value weight-400">IP31</span>
                                            </label>
                                            <label class="form_label">
                                                <input v-model="formData.protective_casing.select" value="Ні" type="radio" class="form_radio">
                                                <span class="selected_value weight-400">Ні</span>
                                            </label>
                                            <div class="input_group">
                                                <input v-model="formData.protective_casing.select" value="custom" type="radio" class="form_radio">
                                                <input :class="{ 'border-danger': errors.protective_casing }" v-model="formData.protective_casing.custom.value" class="form_input mobile_drop_input" type="text" placeholder="Інший варіант" />
                                                
                                            </div>
                                            <p class="error_text" v-if="errors.protective_casing">Обов'язкове поле</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="form_group mb-12">
                                    <label class="form_label mb-12">Вентилятори примусового охолодження</label>
                                    <div class="input_group">
                                        <label class="form_label">
                                            <input v-model="formData.forced_cooling_fans" value="Так" type="radio" class="form_checkbox">
                                            <span class="selected_value weight-400">Так</span>
                                        </label>
                                        <label class="form_label">
                                            <input v-model="formData.forced_cooling_fans" value="Ні" type="radio" class="form_checkbox">
                                            <span class="selected_value weight-400">Ні</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <label class="form_label mb-12">Блок керування обдувом VRT-200</label>
                                    <div class="input_group">
                                        <label class="form_label">
                                            <input v-model="formData.control_vrt20" value="Так" type="radio" class="form_checkbox">
                                            <span class="selected_value weight-400">Так</span>
                                        </label>
                                        <label class="form_label">
                                            <input v-model="formData.control_vrt20" value="Ні" type="radio" class="form_checkbox">
                                            <span class="selected_value weight-400">Ні</span>
                                        </label>
                                    </div>
                                </div>

  
                            </div>

                            <div class="form_grid grid_right">
                                <div class="form_group mb-12">
                                    <label class="form_label w-auto mb-12">Антивібраційні опори (4 шт.) </label>
                                    <div class="input_group">
                                        <label class="form_label w-auto">
                                            <input v-model="formData.antivibration_support" value="Так" type="radio" class="form_checkbox">
                                            <span class="selected_value weight-400">Так</span>
                                        </label>
                                        <label class="form_label w-auto">
                                            <input v-model="formData.antivibration_support" value="Ні" type="radio" class="form_checkbox">
                                            <span class="selected_value weight-400">Ні</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <label class="form_label w-auto mb-12">Екрани між первинною та вторинною обмотками</label>
                                    <div class="input_group">
                                        <label class="form_label w-auto">
                                            <input v-model="formData.screens_between_windings" value="Так" type="radio" class="form_checkbox">
                                            <span class="selected_value weight-400">Так</span>
                                        </label>
                                        <label class="form_label w-auto">
                                            <input v-model="formData.screens_between_windings" value="Ні" type="radio" class="form_checkbox">
                                            <span class="selected_value weight-400">Ні</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group justify_betwen">
                                        <label class="form_label input-grid gap-20">
                                            <label class="form_label">Напруга короткого замикання, %</label>
                                            <input v-model="formData.voltage_short_circuit" class="form_input" type="text" placeholder="" />
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group justify_betwen">
                                        <label class="form_label input-grid gap-20">
                                            <label class="form_label">Номінальна частота, Гц</label>
                                            <input v-model="formData.nominal_frequency" class="form_input" type="text" placeholder="" />
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group justify_betwen">
                                        <label class="form_label input-grid gap-20">
                                            <label class="form_label">Струм холостого ходу, %</label>
                                            <input v-model="formData.idle_current" class="form_input" type="text" placeholder="" />
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group justify_betwen">
                                        <label class="form_label input-grid gap-20">
                                            <label class="form_label">Втрати тр-ра у режимі х.х., Вт</label>
                                            <input v-model="formData.losses_hh" class="form_input" type="text" placeholder="" />
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group justify_betwen">
                                        <label class="form_label input-grid gap-20">
                                            <label class="form_label">Втрати тр-ра у режимі к.з., Вт</label>
                                            <input v-model="formData.losses_kz" class="form_input" type="text" placeholder="" />
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group justify_betwen">
                                        <label class="form_label input-grid gap-20">
                                            <label class="form_label">Габаритні розміри Д*Ш*В, мм</label>
                                            <input v-model="formData.overall_dimensions" class="form_input" type="text" placeholder="" />
                                        </label>
                                    </div>
                                </div>
                                <div class="form_group mb-12">
                                    <div class="input_group justify_betwen">
                                        <label class="form_label input-grid">
                                            <label class="form_label">Сейсмостійкість по шкалі MSK-64, балів</label>
                                            <input v-model="formData.seismic_resistance" class="form_input" type="text" placeholder="" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="form_group">
                        <label class="form_label">Додаткова інформація</label>
                        <textarea v-model="formData.additional_information" class="form_input form_textarea additional_text" rows="5" placeholder="Додаткова інформація"></textarea>
                        <a class="btn-submit" v-on:click="submit()">
                            <span v-if="!payload">Відправити</span>
                            <span v-if="payload">Зачекайте..</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="overlay" v-if="modal"></div>
        <div class="modal" v-if="modal">
            <a class="close_btn" v-on:click="modal = false">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.5 1.91L13.09 0.5L7.5 6.09L1.91 0.5L0.5 1.91L6.09 7.5L0.5 13.09L1.91 14.5L7.5 8.91L13.09 14.5L14.5 13.09L8.91 7.5L14.5 1.91Z" fill="#356EEF"/>
                </svg>
            </a>
            <div class="modal_form_content">
                <p class="modal_title">Заявка №{{ modal_id }} від {{ modal_date }}</p>
                <p class="modal_text">Ваша Заявка на сухий трансформатор зареєстрована та прийнята, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                <p class="modal_text">Для зручності цю заявку в форматі pdf надіслано Вам на електронну пошту, а також можете переглянути її <a :href="modal_link" target="_blank" class="modal_link">за посиланням</a> </p>
                <a class="modal_btn" v-on:click="modal = false"><p>ОК</p></a>
            </div>
        </div>
    </section>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Label from '../Jetstream/Label.vue';
import Input from '../Jetstream/Input.vue';


export default {
    props: {
        file: {
            type: String,
            required: false,
        }
    },

    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        Input,
        Label
    },
    layout: CommonLayout,
    data() {
        return {
            modal: false,
            payload: false,
            formData: {
                org_name: null,
                phone: null,
                name: null,
                email: null,
                address: null,

                power: {
                    select: 'selected',
                    selected: {
                        value: 1000,
                    },
                    custom: {
                        value: null,
                    },
                },
                material_BH_KB: {
                    select: 10,
                    custom: {
                        value: null,
                    },
                },
                material_HH_KB: {
                    select: 0.4,
                    custom: {
                        value: null,
                    },
                },
                series: 'Стандартні втрати',
                type: [],
                
                destination: {
                    select: 'Розподіл електроенергії',
                    custom: {
                        value: null,
                    },
                },
                type_connect_HH: {
                    select: 'Плетена шина',
                    custom: {
                        value: null,
                    },
                },
                temperature_control_unit: {
                    select: 'Т-154',
                    custom: {
                        value: null,
                    },
                },
                temperature_sensors: {
                    select: 'РТ-100 (4шт.)',
                    custom: {
                        value: null,
                    },
                },
                protective_casing: {
                    select: 'Ні',
                    custom: {
                        value: null,
                    },
                },
                winding_scheme: {
                    select: '∆/Yn-11',
                    custom: {
                        value: null,
                    },
                },
                voltage_method: {
                    select: '+/- 2х2,5%',
                    custom: {
                        value: null,
                        value_2: null,
                    },
                },

                material_BH: 'Al',
                material_HH: 'Al',
                type_HH: 'Зверху',
                type_BH: 'Зверху',
                heat_resistance_class: 'F',
                operating_temperature: {
                    select: '-25 °C  +40 °C',
                    custom: {
                        value: null,
                    },
                },
                count: null,

                protection_system_sealed: [],
                protection_system_tank: [],
                screens_between_windings: 'Ні',
                antivibration_support: 'Так',
                forced_cooling_fans: 'Так',
                control_vrt20: 'Так',
                terminal_type_BH: [],

                voltage_short_circuit: null,
                nominal_frequency: null,
                idle_current: null,
                losses_hh: null,
                losses_kz: null,
                overall_dimensions: null,
                seismic_resistance: null,
                additional_information: null,
            },
            is_toggle: false,
            show_error: false,
            errors: {
                org_name: false,
                phone: false,
                name: false,
                email: false,
                address: false,

                power: false,
                material_BH_KB: false,
                material_HH_KB: false,
                destination: false,
                type_connect_HH: false,
                temperature_control_unit: false,
                temperature_sensors: false,
                protective_casing: false,
                winding_scheme: false,
                voltage_method_1: false,
                voltage_method_2: false,
                operating_temperature: false,
                count: false,
            },
            modal_id: null,
            modal_date: null,
            modal_link: null,
        }
    },

    watch: {
        'formData': {
            handler: function() {
                this.validateFields();
            },
            deep: true
        },
        'formData.power.select': {
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue && newValue == 'selected') {
                    this.formData.power.custom.value = null;
                }
            },
        },
        'formData.power.selected.value': {
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.formData.power.select = 'selected';
                    this.formData.power.custom.value = null;
                }
            },
        },
        'formData.power.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.power.select = 'custom';
                }
            },
        },

        'formData.material_BH_KB.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.material_BH_KB.custom.value = null;
                }
            },
        },
        'formData.material_BH_KB.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.material_BH_KB.select = 'custom';
                }
            },
        },

        'formData.material_HH_KB.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.material_HH_KB.custom.value = null;
                }
            },
        },
        'formData.material_HH_KB.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.material_HH_KB.select = 'custom';
                }
            },
        },

        'formData.destination.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.destination.custom.value = null;
                }
            },
        },
        'formData.destination.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.destination.select = 'custom';
                }
            },
        },

        'formData.temperature_control_unit.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.temperature_control_unit.custom.value = null;
                }
            },
        },
        'formData.temperature_control_unit.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.temperature_control_unit.select = 'custom';
                }
            },
        },

        'formData.temperature_sensors.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.temperature_sensors.custom.value = null;
                }
            },
        },
        'formData.temperature_sensors.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.temperature_sensors.select = 'custom';
                }
            },
        },

        'formData.protective_casing.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.protective_casing.custom.value = null;
                }
            },
        },
        'formData.protective_casing.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.protective_casing.select = 'custom';
                }
            },
        },

        'formData.type_connect_HH.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.type_connect_HH.custom.value = null;
                }
            },
        },
        'formData.type_connect_HH.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.type_connect_HH.select = 'custom';
                }
            },
        },

        'formData.winding_scheme.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.winding_scheme.custom.value = null;
                }
            },
        },
        'formData.winding_scheme.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.winding_scheme.select = 'custom';
                }
            },
        },

        'formData.voltage_method.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom' && newValue !== 'custom_2') {
                    this.formData.voltage_method.custom.value = null;
                    this.formData.voltage_method.custom.value_2 = null;
                }
            },
        },
        'formData.voltage_method.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.voltage_method.select = 'custom';
                    this.formData.voltage_method.custom.value_2 = null;
                }
            },
        },
        'formData.voltage_method.custom.value_2': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.voltage_method.select = 'custom_2';
                    this.formData.voltage_method.custom.value = null;
                }
            },
        },

        'formData.operating_temperature.select': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== 'custom') {
                    this.formData.operating_temperature.custom.value = null;
                }
            },
        },
        'formData.operating_temperature.custom.value': {
            handler: function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    this.formData.operating_temperature.select = 'custom';
                }
            },
        },
    },

    methods: {
        acceptNumber() {
            var x = this.formData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.formData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },

        toggle() {
            this.is_toggle = !this.is_toggle;
            this.$forceUpdate();
        },

        validateFields() {
            this.errors = {
                org_name: false,
                phone: false,
                name: false,
                email: false,
                address: false,

                power: false,
                material_BH_KB: false,
                material_HH_KB: false,
                destination: false,
                type_connect_HH: false,
                temperature_control_unit: false,
                temperature_sensors: false,
                protective_casing: false,
                winding_scheme: false,
                voltage_method_1: false,
                voltage_method_2: false,
                operating_temperature: false,
                count: false,
            };

            if (!this.formData.org_name) {
                this.errors.org_name = true;
                return false;
            } else {
                this.errors.org_name = false;
            }
            if (!this.formData.phone) {
                this.errors.phone = true;
                return false;
            } else {
                this.errors.phone = false;
            }
            if (!this.formData.name) {
                this.errors.name = true;
                return false;
            } else {
                this.errors.name = false;
            }
            if (!this.formData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.formData.email))) {
                this.errors.email = true;
                return false;
            } else {
                this.errors.email = false;
            }
            if (!this.formData.address) {
                this.errors.address = true;
                return false;
            } else {
                this.errors.address = false;
            }
            
            if (this.formData.power.select === 'custom' && !this.formData.power.custom.value) {
                this.errors.power = true;
                return false;
            } else {
                this.errors.power = false;
            }
            if (this.formData.material_BH_KB.select === 'custom' && !this.formData.material_BH_KB.custom.value) {
                this.errors.material_BH_KB = true;
                return false;
            } else {
                this.errors.material_BH_KB = false;
            }
            if (this.formData.material_HH_KB.select === 'custom' && !this.formData.material_HH_KB.custom.value) {
                this.errors.material_HH_KB = true;
                return false;
            } else {
                this.errors.material_HH_KB = false;
            }
            if (this.formData.destination.select === 'custom' && !this.formData.destination.custom.value) {
                this.errors.destination = true;
                return false;
            } else {
                this.errors.destination = false;
            }
            if (this.formData.type_connect_HH.select === 'custom' && !this.formData.type_connect_HH.custom.value) {
                this.errors.type_connect_HH = true;
                return false;
            } else {
                this.errors.type_connect_HH = false;
            }
            if (this.formData.temperature_control_unit.select === 'custom' && !this.formData.temperature_control_unit.custom.value) {
                this.errors.temperature_control_unit = true;
                return false;
            } else {
                this.errors.temperature_control_unit = false;
            }
            if (this.formData.temperature_sensors.select === 'custom' && !this.formData.temperature_sensors.custom.value) {
                this.errors.temperature_sensors = true;
                return false;
            } else {
                this.errors.temperature_sensors = false;
            }
            if (this.formData.protective_casing.select === 'custom' && !this.formData.protective_casing.custom.value) {
                this.errors.protective_casing = true;
                return false;
            } else {
                this.errors.protective_casing = false;
            }
            if (this.formData.winding_scheme.select === 'custom' && !this.formData.winding_scheme.custom.value) {
                this.errors.winding_scheme = true;
                return false;
            } else {
                this.errors.winding_scheme = false;
            }
            if (this.formData.voltage_method.select === 'custom' && !this.formData.voltage_method.custom.value) {
                this.errors.voltage_method_1 = true;
                return false;
            } else {
                this.errors.voltage_method_1 = false;
            }
            if (this.formData.voltage_method.select === 'custom_2' && !this.formData.voltage_method.custom.value_2) {
                this.errors.voltage_method_2 = true;
                return false;
            } else {
                this.errors.voltage_method_2 = false;
            }
            if (this.formData.operating_temperature.select === 'custom' && !this.formData.operating_temperature.custom.value) {
                this.errors.operating_temperature = true;
                return false;
            } else {
                this.errors.operating_temperature = false;
            }

            if (!this.formData.count) {
                this.errors.count = true;
                return false;
            } else {
                this.errors.count = false;
            }

            return true;
        },

        getRequestData() {
            let data = {
                trans_type: 'сухой',
                org_name: this.formData.org_name,
                phone: this.formData.phone,
                name: this.formData.name,
                email: this.formData.email,
                address: this.formData.address,
                power: this.formData.power,
                material_BH_KB: this.formData.material_BH_KB,
                material_HH_KB: this.formData.material_HH_KB,
                series: this.formData.series,
                type: this.formData.type,
                destination: this.formData.destination,
                type_connect_HH: this.formData.type_connect_HH,
                temperature_control_unit: this.formData.temperature_control_unit,
                temperature_sensors: this.formData.temperature_sensors,
                protective_casing: this.formData.protective_casing,
                winding_scheme: this.formData.winding_scheme,
                voltage_method: this.formData.voltage_method,
                material_BH: this.formData.material_BH,
                material_HH: this.formData.material_HH,
                type_HH: this.formData.type_HH,
                type_BH: this.formData.type_BH,
                heat_resistance_class: this.formData.heat_resistance_class,
                operating_temperature: this.formData.operating_temperature,
                count: this.formData.count,
                protection_system_sealed:this.formData.protection_system_sealed,
                protection_system_tank: this.formData.protection_system_tank,
                screens_between_windings: this.formData.screens_between_windings,
                antivibration_support: this.formData.antivibration_support,
                forced_cooling_fans: this.formData.forced_cooling_fans,
                control_vrt20: this.formData.control_vrt20,
                terminal_type_BH: this.formData.terminal_type_BH,
                voltage_short_circuit: this.formData.voltage_short_circuit,
                nominal_frequency: this.formData.nominal_frequency,
                idle_current: this.formData.idle_current,
                losses_hh: this.formData.losses_hh,
                losses_kz: this.formData.losses_kz,
                overall_dimensions: this.formData.overall_dimensions,
                seismic_resistance: this.formData.seismic_resistance,
                additional_information: this.formData.additional_information,
            };

            if (this.formData.power.select == 'custom') {
                data.power = this.formData.power.custom.value;
            } else {
                data.power = this.formData.power.selected.value;
            }

            if (this.formData.material_BH_KB.select == 'custom') {
                data.material_BH_KB = this.formData.material_BH_KB.custom.value;
            } else {
                data.material_BH_KB = this.formData.material_BH_KB.select;
            }

            if (this.formData.material_HH_KB.select == 'custom') {
                data.material_HH_KB = this.formData.material_HH_KB.custom.value;
            } else {
                data.material_HH_KB = this.formData.material_HH_KB.select;
            }

            if (this.formData.destination.select == 'custom') {
                data.destination = this.formData.destination.custom.value;
            } else {
                data.destination = this.formData.destination.select;
            }

            if (this.formData.type_connect_HH.select == 'custom') {
                data.type_connect_HH = this.formData.type_connect_HH.custom.value;
            } else {
                data.type_connect_HH = this.formData.type_connect_HH.select;
            }

            if (this.formData.temperature_control_unit.select == 'custom') {
                data.temperature_control_unit = this.formData.temperature_control_unit.custom.value;
            } else {
                data.temperature_control_unit = this.formData.temperature_control_unit.select;
            }

            if (this.formData.temperature_sensors.select == 'custom') {
                data.temperature_sensors = this.formData.temperature_sensors.custom.value;
            } else {
                data.temperature_sensors = this.formData.temperature_sensors.select;
            }

            if (this.formData.protective_casing.select == 'custom') {
                data.protective_casing = this.formData.protective_casing.custom.value;
            } else {
                data.protective_casing = this.formData.protective_casing.select;
            }

            if (this.formData.winding_scheme.select == 'custom') {
                data.winding_scheme = this.formData.winding_scheme.custom.value;
            } else {
                data.winding_scheme = this.formData.winding_scheme.select;
            }

            if (this.formData.voltage_method.select !== 'custom' && this.formData.voltage_method.select !== 'custom_2') {
                if (this.formData.voltage_method.select == '+/- 2х2,5%') {
                    data.voltage_method = 'Переключення без збудження (ПБЗ), %: ' + this.formData.voltage_method.select;
                } else {
                    data.voltage_method = 'Регулювання під навантаженням (РПН), %: ' + this.formData.voltage_method.select;
                }
            } else {
                if (this.formData.voltage_method.select == 'custom') {
                    data.voltage_method = 'Переключення без збудження (ПБЗ), %: ' + this.formData.voltage_method.custom.value;
                }

                if (this.formData.voltage_method.select == 'custom_2') {
                    data.voltage_method = 'Регулювання під навантаженням (РПН), %: ' + this.formData.voltage_method.custom.value_2;
                }
            }

            if (this.formData.operating_temperature.select == 'custom') {
                data.operating_temperature = this.formData.operating_temperature.custom.value;
            } else {
                data.operating_temperature = this.formData.operating_temperature.select;
            }

            if (this.formData.type) {
                data.type = this.formData.type.join();
            }
            if (this.formData.protection_system_sealed) {
                data.protection_system_sealed = this.formData.protection_system_sealed.join();
            }
            if (this.formData.protection_system_tank) {
                data.protection_system_tank = this.formData.protection_system_tank.join();
            }
            if (this.formData.terminal_type_BH) {
                data.terminal_type_BH = this.formData.terminal_type_BH.join();
            }
            
            return data;
        },

        submit() {
            if (!this.payload) {
                this.show_error = false;
                this.payload = true;

                let isValid = this.validateFields();

                if (isValid) {
                    axios.post(this.route('send.form.dry'), this.getRequestData())
                    .then((result) => {
                        this.modal_id = result.data.id;
                        this.modal_date = result.data.created_at;
                        this.modal_link = result.data.file;
                        this.modal = true;
                        this.payload = false;
                    }).catch((error) => {
                        window.scroll(0, 0);
                        this.show_error = true;
                        this.payload = false;
                    })
                } else {
                    window.scroll(0, 0);
                    this.show_error = true;
                    this.payload = false;
                }
            }
        }
    }
};
</script>

<style scoped>
.mt-8 {
    margin-top: 80px;
}
.mt-24 {
    margin-top: 24px;
}
.mr-9 {
    margin-right: 90px;
}
.mb-5 {
    margin-bottom: 50px;
}
.mb-12 {
    margin-bottom: 12px;
}
.gap-20 {
    gap: 20px;
}
#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 80px 60px 0 20px;
}
.select_grid {
    display: flex;
    justify-content: space-between;
    gap: 110px;
}
.btn-download {
    padding: 13px 30px;
    width: 261px;
    height: 51px;
    border: 1px solid #356EEF;
    border-radius: 4px;
    cursor: pointer;
}
.btn-download:hover {
    background-color: #356EEF;
    color: #fff;
}
.btn-download:hover #download-icon {
    fill: #fff;
}
.btn-download svg{
    margin-right: 15px;
}
.head_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 50px;
    color: #000000;

}
.subtitle {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    color: #000000;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.form_subtitle {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}
.form_label {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    /* cursor: pointer; */
}
.form_label_secondary {
    font-weight: 400;
}
.form_input {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 200px;
    height: 100%;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.customer_info .form_input {
    max-width: 100%;
}
.count_input {
    max-width: 55px;
}
.form_input::placeholder {
    color: #6C757D;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.flex_form {
    width: 100%;
}

textarea {
    font-family: 'Helvetica'!important;
}

.block_title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.form_select {
  appearance: none;
  background-image: url('/img/caret.svg');
  background-repeat: no-repeat;
  background-position: right 0.7rem top 50%;
  background-size: 0.65rem auto;
}

.form_radio {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.form_checkbox {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.input_group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 18px;
}

.selected_value {
    margin-left: 18px;
    cursor: pointer;
}

.toggle_header {
    display: flex;
    align-items: center;
    height: 55px;
    justify-content: space-between;
    padding: 0 25px 0 25px;
    background: #C8E4FF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    cursor: pointer;
}

.cater.active {
    transform: rotate(180deg);
}

.toggle_content {
    padding: 25px;
    border: 1px solid #C8E4FF;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.toggle_header.active {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.btn-submit {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 30px;
    width: 180px;
    height: 49px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 20px;
}

.btn-submit:hover {
    background: #FFF;
    border: 1px solid #356EEF;
    color: #356EEF;
}

.toggle {
    width: 100%;
}

.toggle_row {
    display: flex;
    gap: 24px;
}

.additional_text {
    width: 306px;
}

.justify_betwen {
    justify-content: space-between;
}

.form_select {
    width: 100%;
}

.border-danger {
    border: 1px solid red;
    color: red;
}

.alert-danger {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.75rem 1.25rem;
    color: #721c24;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}

.error_text {
    color: red;
}

.modal_title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: #212529;
}
.modal_text {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
.modal_link {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
}

.modal_btn {
    width: 150px;
    height: 46px;
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #FFFFFF;
    background: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 16px;
    cursor: pointer;
}

.close_btn {
    position: absolute;
    right: 20px;
    cursor: pointer;
}

.grid_right .form_label {
    width: 100%;
}

.grid_right .w-auto {
    width: auto!important;
}

.weight-400 {
    font-weight: 400;
}

.max-width {
    max-width: 246px;
}
.max-width-radio {
    max-width: 208px;
    justify-content: space-between;
}
.max-width-radio-init {
    max-width: 238px;
    justify-content: space-between;
}

.flex-betwen {
    display: flex;
    justify-content: space-between;
}

@media (max-width: 1180px) {
    .toggle_row {
        flex-direction: column;
    }
    .additional_text {
        width: 396px;
    }
    .select_grid {
        gap: 50px;
    }

    .btn-download {
        display: none;
    }
    .flex-row {
        flex-direction: column!important;
    }
    .title {
        font-size: 30px;
        line-height: 42px;
    }
    .subtitle {
        font-size: 18px;
        line-height: 22px;
    }
    .flex_centered {
        align-items: center;
    }
}

@media (max-width: 980px) {
    .to_hide {
        display: none;
    }
    .form_grid.hidden {
        display: block!important;
    }
}

@media (max-width: 880px) {
    .toggle_content .form_input {
        max-width: 135px;
    }
    .modal {
        width: 100%;
    }
}

@media (max-width: 780px) {
    .container {
        padding: 60px 1rem 0 1rem;
    }
    .flex-group {
        flex-direction: column;
    }
    .trans_img {
        display: none;
    }
    .toggle_content {
        padding: 20px;
    }
    .toggle_content .select_grid {
        flex-direction: column;
    }
    .toggle_content .input-grid{
        width: 100%;
        flex-direction: column;
        align-items: start;
    }
    .toggle_content .form_input {
        max-width: 100%;
    }
    .main_content .select_grid {
        gap: 0;
        flex-direction: column;
    }
}

@media (max-width: 420px) {
    .toggle_content {
        padding: 15px;
    }
    .mobile_drop_input {
        max-width: 145px!important;
    }
    .mobile_selects .selected_value {
            margin-left: 5px!important;
    }
}

</style>
